import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { sendItemsToLogist } from '../../../shared/api/customs.api'
import { apiErrorText } from '../../../shared/api/errorText'
import { toast } from '../../../shared/ui/toastStore'

const plural = (n: number) => (n === 1 ? 'позиция' : n >= 2 && n <= 4 ? 'позиции' : 'позиций')

/**
 * Кнопка «Отправить брокеру» в панели выбранных позиций (17.10.2026): позиции
 * уходят логисту в «Нетарифку». Логист сам собирает из них запрос брокеру.
 * Отправить можно только «Китай» / «Производители» / «Стоки» — про остальные
 * и про уже отправленные говорим в сообщении.
 */
export function useSendToLogist(requestId: string | undefined, onDone: () => void) {
  const queryClient = useQueryClient()
  const [isSending, setIsSending] = useState(false)

  async function send(itemIds: string[]) {
    if (!requestId || itemIds.length === 0 || isSending) return
    setIsSending(true)
    try {
      const { sent, alreadySent, skipped } = await sendItemsToLogist(itemIds)
      const notes: string[] = []
      if (alreadySent > 0) notes.push(`уже у логиста: ${alreadySent}`)
      if (skipped > 0) {
        notes.push(
          `пропущено ${skipped} — отправить можно только позиции «Китай», «Производители», «Стоки»`,
        )
      }
      const tail = notes.length > 0 ? `. ${notes.join('; ')}` : ''
      if (sent > 0) {
        toast.success(`Отправлено логисту: ${sent} ${plural(sent)}${tail}`)
        onDone()
      } else {
        toast.error(`Ничего не отправлено${tail}`)
      }
      await queryClient.invalidateQueries({ queryKey: ['requests', requestId] })
    } catch (e) {
      toast.error(apiErrorText(e, 'Не удалось отправить логисту'))
    } finally {
      setIsSending(false)
    }
  }

  return { send, isSending }
}
